<template>
<div>
  <vv-box :title="$t('userAccount.commandes')" :unpadded="false" class="userCommandeBox">
    <div class="textCommande">Si vos formations ou vos vins n’apparaissent pas dans votre espace, n’hésitez pas à saisir le code de votre commande reçu par email.</div>
    <div class="userCommande">
        <input type="text" class="inputCommande" placeholder="Code de commande" v-model="commandeCode">
        <vv-button class="userValidateCommande" @click="confirmeCode" v-if="!isLoading">
          {{ $t('userAccount.codeConfirme') }}
        </vv-button>
        <div v-else>
          <Spinner />
        </div>
      </div>
    <div class="responceCommande" v-if="displayResponseCommande">
      <div class="responceCommandeTrue" v-if="!errorResponceCommande">{{ $t('userAccount.codeIsGood') }}</div>
      <div class="responceCommandeFalse" v-if="errorResponceCommande">{{ $t('userAccount.codeIsWrong') }}</div>
    </div>
  </vv-box>
  <vv-box :title="$t('userAccount.personalInformation')" :unpadded="true">
    <div class="container">
      <vv-form-text-input
        label="firstname"
        id="firstname"
        v-model="firstname"
        :validate="'required'"
      />
      <vv-form-text-input
        label="lastname"
        id="lastname"
        v-model="lastname"
        :validate="'required'"
      />
      <vv-form-text-input label="email" id="email" v-model="email" type="email" :disabled="true" />
      <!-- <vv-form-birthday-input label="birthday" id="birthday" v-model="birthday" /> -->
      <vv-form-mask-input
        id="birthday"
        label="birthday"
        name="birthday"
        v-model="birthday"
        required
        placeholder="JJ/MM/AAAA"
        :cleave="{ date: true, datePattern: ['d', 'm', 'Y'] }"
        :validate="'legalAge|date_format:dd/MM/yyyy'"
        :value="birthdate"
      />

      <div class="gender-wrapper">
        <span class="gender-label">{{ $t('forms.gender.label') }}</span>
        <vv-radio-bubble
          v-for="genderItem in genderList"
          name="genderRadioBubbles"
          :key="genderItem.value"
          :value="genderItem.value"
          :label="genderItem.label"
          v-model="gender"
        />
      </div>

      <vv-form-text-input label="phone" id="phone" v-model="phone" :validate="'numeric'" />
      <vv-form-checkbox-input label="newsletter" id="newsletter" v-model="newsletter" />

      <vv-button class="validate-button" @click="onUpdate">
        {{ $t('forms.validate') }}
      </vv-button>
      <br v-if="error || success" />
      <span v-if="error">{{ $t(errorMessage) }}</span>
      <span v-if="success">{{ $t('forms.updatedWithSuccess') }}</span>

      <!-- fix this -->
      <br /><br />
      <span @click.prevent="showPassword = !showPassword" class="change-password-cta">{{
        $t('userAccount.changePassword')
      }}</span>
      <br />

      <div v-if="showPassword">
        <br />
        <vv-form-text-input
          label="oldPassword"
          id="oldPassword"
          v-model="oldPassword"
          type="password"
        />
        <vv-form-text-input
          label="newPassword"
          id="newPassword"
          v-model="newPassword"
          type="password"
          :validate="'required'"
        />
        <vv-form-text-input
          label="confirmNewPassword"
          id="confirmNewPassword"
          v-model="confirmNewPassword"
          type="password"
          :validate="'required'"
        />

        <vv-button class="user-form-width" @click="onPasswordChange">
          {{ $t('forms.updatePassword') }}
        </vv-button>
        <span v-if="errorPassword">{{ $t(errorPasswordMessage) }}</span>
        <span v-if="successPassword">{{ $t('forms.updatedWithSuccess') }}</span>
      </div>
    </div>
  </vv-box>
</div>
</template>

<script>
import VvBox from '@/components/common/VvBox'
import VvFormTextInput from '@/components/common/forms/VvFormTextInput'
import VvFormCheckboxInput from '@/components/common/forms/VvFormCheckboxInput'
import VvFormMaskInput from '@/components/common/forms/VvFormMaskInput'
import VvRadioBubble from '@/components/common/VvRadioBubble'
import VvButton from '@/components/common/VvButton'
import userMixin from '@/mixins/user'
import Spinner from '@/components/layout/Spinner'

import { functions } from '@/services/firebase'

export default {
  name: 'UserAccountGeneralInformations',
  mixins: [userMixin],
  components: {
    VvBox,
    VvFormTextInput,
    VvFormMaskInput,
    VvFormCheckboxInput,
    VvRadioBubble,
    VvButton,
    Spinner
  },
  data: () => ({
    firstname: '',
    lastname: '',
    gender: '',
    email: '',
    birthday: '',
    phone: '',
    newsletter: false,
    isLoading: false,
    showPassword: false,
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
    error: false,
    errorPassword: false,
    errorMessage: '',
    errorPasswordMessage: '',
    success: false,
    successPassword: false,
    commandeCode: '',
    displayResponseCommande: false,
    errorResponceCommande: false,
  }),
  computed: {
    genderList() {
      return [
        { label: this.$t('forms.gender.female'), value: 'female' },
        { label: this.$t('forms.gender.male'), value: 'male' },
        { label: this.$t('forms.gender.unknow'), value: 'unknow' }
      ]
    },
    birthdate() {
      return this.birthday
    }
  },
  methods: {
    async onPasswordChange() {
      this.errorPassword = false
      this.successPassword = false
      this.errorPasswordMessage = 'forms.updatedWithError'

      if (this.newPassword && this.confirmNewPassword !== this.newPassword) {
        this.errorPassword = true
        setTimeout(() => (this.errorPassword = false), 4000)
        this.errorPasswordMessage = 'custom/password-mismatch'
        return
      }

      try {
        await this.updateUserPassword(this.oldPassword, this.newPassword)

        this.successPassword = true
        setTimeout(() => (this.successPassword = false), 4000)
      } catch (error) {
        this.errorPassword = true
        if (error.code) {
          this.errorPasswordMessage = error.code
        }

        setTimeout(() => (this.errorPassword = false), 4000)
      }
    },
    async onUpdate() {
      let errorValidation = false
      this.error = false
      this.errorMessage = 'forms.updatedWithError'
      this.success = false

      const validFields = await Promise.all(
        this.$children.map(async child => {
          errorValidation = !(await child.$validator.validateAll())
        })
      )

      // validate birthday
      if (validFields.some(verification => verification === false)) {
        return
      }

      if (!errorValidation) {
        const updatePayload = {
          firstname: this.firstname,
          lastname: this.lastname,
          gender: this.gender,
          phone: this.phone,
          birthday: this.birthday,
          newsletter: this.newsletter
        }

        try {
          await this.updateUserInformations(updatePayload)

          this.success = true
          setTimeout(() => (this.success = false), 4000)
        } catch (error) {
          this.error = true
          if (error.code) {
            this.errorMessage = error.code
          }

          setTimeout(() => (this.error = false), 4000)
        }
      }
    },
    async confirmeCode() {
      this.isLoading = true
      const callable = functions.httpsCallable('unlockCommandShopify')
      const res = await callable({
        code: this.commandeCode,
        userEmail: this.email
      })
      if (res.data.error === true) {
        this.errorResponceCommande = true
      } else {
        this.errorResponceCommande = false
      }
      this.displayResponseCommande = true
      this.isLoading = false
    }
  },
  provide() {
    return { $validator: this.$validator }
  },
  created() {
    if (this.user) {
      this.firstname = this.user.firstname || ''
      this.lastname = this.user.lastname || ''
      this.gender = this.user.gender || 'unknow'
      this.email = this.user.email
      this.phone = this.user.phone || ''
      this.birthday = this.user.birthday || ''
      this.newsletter = this.user.newsletter || false
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  margin: 17px 17px 23px 17px;
}

.change-password-cta {
  float: left;
  margin-bottom: 5px;
  text-decoration: underline;
}

.gender-wrapper {
  margin: 6px 0;

  .gender-label {
    display: block;
  }
}
.validate-button{
  width: 200px;
  margin-left: 40%;
  @media screen and (max-width: 719px) {
    width: 76%; 
    margin-left: 0;  
  }
}

.userCommande {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 15px;
}

.inputCommande {
  width: 200px;
  margin-right: 20px;
  outline: none;
  border: none;
  background-color: #f6f6f6;
  height: 16px;
  border-radius: 5px;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  padding: 10px;
  font-weight: 900;
  font-size: 11px;
}

.userCommandeBox {
  margin-bottom: 35px;
}

.responceCommande {
  margin-top: 5px;
  font-weight: 500;
}

.responceCommandeTrue {
  color: green;
}

.responceCommandeFalse {
  color: red;
}
</style>
